// This is a temporary solution until we upgrade to React 18

import { useMemo } from 'react';

let id = 0;
export function useId() {
  return useMemo(() => `${id++}`, []);
}
